module.exports = function getResource(label, vars = []) {
    const resources = {
        continueToCheckoutButton: 'Passer à la caisse',
        applePayButton: 'Apple Pay',
        checkoutButton: 'Passer à la caisse'
    };

    return resources[label];
};
